import React from 'react';
import './AboutUs.css';
import { useInView } from 'react-intersection-observer';
import ScrollToTopScroller from '../elements/ScrollerToTop';
import Footer from '../components/Footer';
import logo from '../asset/Images/logo.png';

const AboutUs = () => {
  const { ref: logoRef, inView: logoInView } = useInView({ triggerOnce: true });
  const { ref: pokeRef, inView: pokeInView } = useInView({ triggerOnce: true });
  const { ref: donburiRef, inView: donburiInView } = useInView({ triggerOnce: true });
  const { ref: sushiRef, inView: sushiInView } = useInView({ triggerOnce: true });

  return (
    <>
<div className="about-us" style={{ marginTop: '120px' }}>
  <div className="container" style={{ maxWidth: '900px', margin: '0 auto' }}>
    
    {/* Header Section with Logo on Left */}
    <div className="row mb-5 align-items-center">
      <div className="col-lg-6">
        <img
          src={logo}
          alt="Lin's Bistro"
          className="logo img-fluid"
        />
      </div>
      <div className={`col-lg-6 slide-in-right ${logoInView ? 'show' : ''}`} ref={logoRef}>
        <h1>LIN'S BISTRO</h1>
        <p>
          Lin's Bistro is your destination for authentic Chinese and Thai cuisine. With a perfect blend of traditional recipes and modern flavors, we bring you dishes that excite your taste buds and warm your heart. Come experience the best of Asian cuisine right here in Lawrenceville!
        </p>
      </div>
    </div>

    {/* Stir-Fry Section - Image on Right */}
    <div className="row mb-5 align-items-center">
      <div className="col-lg-6 order-lg-2">
        <img
          src="https://example.com/stirfry.jpg"
          alt="Stir-Fry"
          className="img-fluid rounded"
        />
      </div>
      <div className={`col-lg-6 order-lg-1 slide-in-left ${pokeInView ? 'show' : ''}`} ref={pokeRef}>
        <h3>Our Signature Stir-Fry</h3>
        <p>
          Experience the vibrant flavors of our signature stir-fry dishes. Made with fresh ingredients and seasoned to perfection, our stir-fry options range from savory beef and chicken to tofu and mixed vegetables.
        </p>
        <p>Here's how you can customize your stir-fry:</p>
        <ul>
          <li>Step 1: Choose your protein (Chicken, Beef, Tofu, or Shrimp).</li>
          <li>Step 2: Pick your vegetables (Broccoli, Snap Peas, Bell Peppers, and more).</li>
          <li>Step 3: Select your sauce (Sweet & Sour, Garlic, or Thai Basil).</li>
          <li>Step 4: Pair with steamed rice or noodles.</li>
        </ul>
      </div>
    </div>

    {/* Curry Section - Image on Left */}
    <div className="row mb-5 align-items-center">
      <div className="col-lg-6">
        <img
          src="https://example.com/curry.jpg"
          alt="Thai Curry"
          className="img-fluid rounded"
        />
      </div>
      <div className={`col-lg-6 slide-in-right ${donburiInView ? 'show' : ''}`} ref={donburiRef}>
        <h3>Authentic Thai Curries</h3>
        <p>
          Dive into the rich, aromatic world of Thai curries. From the creamy and mild Yellow Curry to the spicy and bold Red Curry, each dish is crafted with authentic ingredients and served with fragrant jasmine rice.
        </p>
        <p>Perfect for those who love a bit of spice and a lot of flavor.</p>
      </div>
    </div>

    {/* Noodle Section - Image on Right */}
    <div className="row mb-5 align-items-center">
      <div className="col-lg-6 order-lg-2">
        <img
          src="https://example.com/noodles.jpg"
          alt="Noodles"
          className="img-fluid rounded"
        />
      </div>
      <div className={`col-lg-6 order-lg-1 slide-in-left ${sushiInView ? 'show' : ''}`} ref={sushiRef}>
        <h3>Traditional Noodles</h3>
        <p>
          From classic Pad Thai to savory Lo Mein, our noodle dishes are a customer favorite. Made with fresh vegetables, tender meats, and our signature sauces, they are perfect for any occasion.
        </p>
      </div>
    </div>
  </div>
</div>

    </>
  );
};

export default AboutUs;
